<template>
  <a
    :href="variantUrl"
    @mouseover="hoveron()"
    @mouseout="hoveroff()"
    @click="$emit('click-swatch', { variantId, $event })"
  >
    <div
      class="variant"
      :style="{ backgroundImage: 'url(' + src + ')' }"
    >
      <span class="sr-only">Variant color {{ variant.title }}</span>
    </div>
  </a>
</template>

<script setup>
import useImgUrl from '../composables/useImgUrl'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import useBreakpoints from '../composables/useBreakpoints'

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  variant: {
    type: Object,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
  img: {
    type: String,
    default: null,
  },
})
const emit = defineEmits(['hoveron', 'hoveroff', 'click-swatch'])

const store = useStore()
const { imgUrl } = useImgUrl()
const src = imgUrl(props.img, `_500x500_crop_center`)
const hover = ref(false)
const { screenType } = useBreakpoints()

// COMPUTED
const t = computed(() => store.state.product.type)
const isGlasses = computed(() => {
  return t.value === 'Optical' || t.value === 'Sunglasses'
})
const size = computed(() => {
  if (screenType.value === 'xs') {
    return 64
  }
  return isGlasses.value ? 82 : 70
})
const width = computed(() => {
  if (isGlasses.value) {
    return size.value * 0.87 + 'px'
  }
  return height.value
})
const height = computed(() => (isGlasses.value ? size.value / 2 + 'px' : size.value * 0.72 + 'px'))
const bgSize = computed(() => {
  if (isGlasses.value) {
    return size.value + 'px'
  }
  return size.value * 1.2 + 'px'
})
const variantUrl = computed(() => {
  return `/products/${props.product.handle}?variant=${props.variant.id}`
})
const variantId = computed(() => {
  return props.variant.id
})

// METHODS
const hoveron = () => {
  hover.value = true
  emit('hoveron', props.variant)
}
const hoveroff = () => {
  hover.value = false
  emit('hoveroff', props.variant)
}
</script>

<style scoped>
.variant {
  background-size: v-bind(bgSize);
  width: v-bind(width);
  height: v-bind(height);
  background-position: center center;
}
</style>
